import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import AuthApi from "../api/authApi";
import {
  buildGroupedParishOptions,
  sortParishesByName,
  type ParishOptionGroup,
} from "../utils/parishLabels";

const authApi = new AuthApi();

interface UseParishOptionsConfig {
  grouped?: boolean;
  includeNoneOther?: boolean;
  autoLoad?: boolean;
}

export function useParishOptions(config: UseParishOptionsConfig = {}) {
  const {
    grouped = false,
    includeNoneOther = false,
    autoLoad = true,
  } = config;
  const [parishList, setParishList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const loadParishList = useCallback(async () => {
    setLoading(true);
    try {
      const response: any = await authApi.getPerishList();
      if (grouped) {
        if (response.success) {
          setParishList(
            buildGroupedParishOptions(response.data, { includeNoneOther }),
          );
        }
      } else if (response.data) {
        setParishList(sortParishesByName(response.data));
      }
    } catch (error: any) {
      toast.error(error.toString());
    } finally {
      setLoading(false);
    }
  }, [grouped, includeNoneOther]);

  useEffect(() => {
    if (autoLoad) {
      loadParishList();
    }
  }, [autoLoad, loadParishList]);

  return {
    parishList: parishList as ParishOptionGroup[] | any[],
    setParishList,
    loading,
    loadParishList,
  };
}
